// <copyright file="softwareupgradeconstant.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 11/19/2025 by Sumanth Satheesh
// </copyright>

import { RolesDescription } from "../../app/features/users/user-form-component/user-form-control.model";
import { CommonConfirmDialog } from "../../app/shared/components/common-confirm-dialog/common-confirm-dialog.model";

// Defines softwareupgradetabapollo.
export const softwareupgradetabapollo = "Apollo";
// Defines softwareupgradefilterapollo.
export const softwareupgradefilterapollo = "apollo";

// Defines softwareupgradetabalta.
export const softwareupgradetabalta = "Alta";
// Defines softwareupgradefilteralta.
export const softwareupgradefilteralta = "alta";
// Defines fallbackVerion.
export const fallbackVerion = "v1";
export const apiSuccess = {
  status: 200,
  Message: "Success"
};
// Defines mobileSoftwareUpgradeEndPoint.
export const mobileSoftwareUpgradeEndPoint = {
  softwareUpgradeComponent: {
    getPackagesByDeviceAndStore: "Packages/packages-by-device",
    getRegionAndCountry: "Packages/regions",
    deletePackageById: "Packages",
    updatePackageStatus: "Packages/package-status",
    completeSoftwarePackage: "Packages/package-complete"
  },
  userManagementAPI: {
    addUser: "administration/users",
    editUser: "administration/users",
    getAllUsers: "administration/users",
    userDetails: "administration/{uid}/users",
    sortOrder: "Ascending",
    orderBy: "Name",
    logOutUser: "auth/logout",
    ValidateAndAuthorizeUser: "auth/web-login",
    silentLogin: "auth/web-silent-login",
    deleteUser: "administration/users"
  },
  fieldRepManagementAPI: {
    getAllFieldReps: "fieldreps",
    fieldRepDetails: "fieldreps/{uid}/fieldrep",
    deleteFieldRep: "fieldreps/{uId}/fieldrep",
    addFieldRep: "fieldreps",
    getAssignedFieldRepsList: "Rollout/{swid}/fieldreps",
    rolloutFieldReps: "Rollout"
  }
};
// Defines SoftwareUpgradeMenuActionLabel.
export const enum SoftwareUpgradeMenuActionLabel {
  ASSIGNREPS = "Assign Reps",
  COMPLETE = "Complete",
  SUSPEND = "Suspend",
  RESUME = "Resume",
  DELETE = "Delete",
  EDIT = "Edit"
}
// Defines softwareUpgradePackageErrorMessage.
export const softwareUpgradePackageErrorMessage = {
  failure: "Failure",
  errorMessage: "Authentication failed"
};
// Defines SOFTWARE_DELETE_DIALOG_DATA.
export const SOFTWARE_DELETE_DIALOG_DATA: CommonConfirmDialog = {
  title: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.DELETED.TITLE",
  message: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.DELETED.MESSAGE"
};
// Defines SOFTWARE_SUSPEND_DIALOG_DATA.
export const SOFTWARE_SUSPEND_DIALOG_DATA: CommonConfirmDialog = {
  title: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.SUSPENED.TITLE",
  message: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.SUSPENED.MESSAGE"
};
// Defines SOFTWARE_RESUME_DIALOG_DATA.
export const SOFTWARE_RESUME_DIALOG_DATA: CommonConfirmDialog = {
  title: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.RESUME.TITLE",
  message: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.RESUME.MESSAGE"
};
// Defines SOFTWARE_EDIT_DIALOG_DATA.
export const SOFTWARE_EDIT_DIALOG_DATA: CommonConfirmDialog = {
  title: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.EDIT.TITLE",
  message: "SOFTWARE_UPDATE.SOFTWARE_UPGRADE_CONFIRM.EDIT.MESSAGE"
};
// Defines priorityValidator.
export const priorityValidator: string[] = [
  "required",
  "email",
  "pattern",
  "minlength",
  "maxlength"
];
// Defines roleDescription.
export const roleDescription: RolesDescription[] = [
  {
    roleName: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_SA",
    roleDescription: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_SA_DESCRIPTION"
  },
  {
    roleName: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_SU",
    roleDescription: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_SU_DESCRIPTION"
  },
  {
    roleName: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_PM",
    roleDescription: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_PM_DESCRIPTION"
  },
  {
    roleName: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_ACM",
    roleDescription: "USERS.USER_FORM.ROLE_DESCRIPTION.ROLE_NAME_ACM_DESCRIPTION"
  }
];
// Defines userFormMainControls.
export const userFormMainControls: string[] = ["firstName", "lastName", "emailAddress", "title"];

// Defines fieldRepFormMainControls.
export const fieldRepFormMainControls: string[] = [
  "firstName",
  "lastName",
  "emailAddress",
  "title",
  "countriesMultiDropdown"
];
// Defines SoftwareUpgradeActions.
export const enum SoftwareUpgradeActions {
  Suspend = "Suspended",
  Delete = "Deleted",
  Complete = "Completed",
  Edit = "Edit"
}
export const CLIENT_TYPE = "web-app";
